<template>
    <div class="door-check-add">
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link to="/extinguisher-reports">
                        Extinguisher Reports</router-link>
                        &raquo;
                        <span v-if="isEdit">
                        <router-link :to="{ name: 'extinguisher-report-view', params: {action: 'view', id: extinguisherReport.site_extinguisher_report_id} }">
                            {{ extinguisherReport.job_number }} | {{ extinguisherReport.prepared_for }}
                        </router-link>
                             &raquo;
                            </span>
                        <span v-if="isEdit">
                                  Edit Extinguisher Report</span><span v-else>  Add Extinguisher Report</span></h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <input
                        name="site_extinguisher_report_id"
                        type="hidden"
                        v-model="extinguisherReport.site_extinguisher_report_id"
                >
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">

                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Report Details</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('job_number')]"
                                               for="job_number">Job Number</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="job_number"
                                                    :class="['form-control', getFieldClasses('job_number')]"
                                                    maxlength="255"
                                                    id="job_number"
                                                    v-model="extinguisherReport.job_number"
                                                    @blur="onFieldBlur('job_number')"
                                            />
                                            <div v-if="isErrorField('job_number')" class="invalid-feedback">This field is required</div>
                                        </div>

                                    </div>
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('prepared_for')]"
                                                for="prepared_for">Prepared for</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="prepared_for"
                                                    :class="['form-control', getFieldClasses('prepared_for')]"
                                                    maxlength="255"
                                                    id="prepared_for"
                                                    v-model="extinguisherReport.prepared_for"
                                                    @blur="onFieldBlur('prepared_for')"
                                            />
                                            <div v-if="isErrorField('prepared_for')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="prepared_by">Prepared by</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="prepared_by"
                                                    :class="['form-control']"
                                                    maxlength="255"
                                                    id="prepared_by"
                                                    v-model="extinguisherReport.prepared_by"
                                            />
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_address')]"
                                               for="client-site">Site Address</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="site_address"
                                                    :class="['form-control', getFieldClasses('site_address')]"
                                                    v-model="extinguisherReport.site_address"
                                                    id="site_address"
                                                    @blur="onFieldBlur('site_address')"
                                            /></div>
                                        <div v-if="isErrorField('site_address')" class="invalid-feedback">This field is required</div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="tamper_tag_colour">Tamper Tag Colour</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="tamper_tag_colour"
                                                    :class="['form-control']"
                                                    maxlength="255"
                                                    id="tamper_tag_colour"
                                                    v-model="extinguisherReport.tamper_tag_colour"
                                            />
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end text-right">
                                            <label :class="[getContainerClasses('bs5306_3_compliant')]">
                                                Extinguisher service in accordance with BS5306-3?</label>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li class="template-option--li">
                                                    <input type="radio" value="Yes" id="bs5306_3_compliant-yes"
                                                           name="bs5306_3_compliant"
                                                           v-model="extinguisherReport.bs5306_3_compliant"
                                                           class="question-option--radio-as-button__1 template-option--radio-as-button__pass"
                                                    >
                                                    <label for="bs5306_3_compliant-yes">Yes</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="No" id="bs5306_3_compliant-no"
                                                           name="bs5306_3_compliant"
                                                           v-model="extinguisherReport.bs5306_3_compliant"
                                                           class="question-option--radio-as-button__3 template-option--radio-as-button__fail"
                                                    >
                                                    <label for="bs5306_3_compliant-no">No</label>
                                                </li>
                                                <li class="template-option--li">
                                                    <input type="radio" value="N/A" id="bs5306_3_compliant-na"
                                                           name="bs5306_3_compliant"
                                                           v-model="extinguisherReport.bs5306_3_compliant"
                                                           class="question-option--radio-as-button__2 template-option--radio-as-button__na"
                                                    >
                                                    <label for="bs5306_3_compliant-na">N/A</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="date-of-inspection">
                                            Date Of Inspection
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="extinguisherReport.date_of_inspection"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="date_of_inspection"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end"  for="overall_notes">
                                            Overall Notes
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea
                                                    class="form-control"
                                                    name="overall_notes"
                                                    maxlength="2000"
                                                    id="overall_notes"
                                                    rows="5"
                                                    v-model="extinguisherReport.overall_notes"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Engineer Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="signature-area" v-if="extinguisherReport.offline_engineer_signature_image != null">
                                                <img v-bind:src="extinguisherReport.offline_engineer_signature_image.data" class="img-fluid">
                                            </div>
                                            <div class="mb-3" v-else-if="extinguisherReport.engineer_signature_image != null">
                                                Report signed
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingEngineerSignature">
                                                    <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="engineerSignaturePad" />
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveEngineerSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearEngineerSignature">Clear signature</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addEditEngineerSignature"
                                                ><span v-if="extinguisherReport.offline_engineer_signature_image != null || extinguisherReport.engineer_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Client Signature
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div class="signature-area" v-if="extinguisherReport.offline_client_signature_image != null">
                                                <img v-bind:src="extinguisherReport.offline_client_signature_image.data" class="img-fluid">
                                            </div>
                                            <div v-else-if="extinguisherReport.client_signature_image != null">
                                                Report signed
                                            </div>
                                            <div class="pt-2">
                                                <div v-if="addingClientSignature">
                                                    <div class="signature-area">
                                                        <VueSignaturePad width="100%" height="200px" ref="clientSignaturePad" />
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-primary w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="saveClientSignature">Save signature</a>
                                                        </div>
                                                        <div class="col-6">
                                                            <a class="btn btn-square btn-lg btn-outline-danger w-100"
                                                                href="javascript:void(0)"
                                                                v-on:click="clearClientSignature">Clear signature</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a v-else class="btn btn-square btn-lg btn-outline-primary"
                                                    href="javascript:void(0)"
                                                    v-on:click="addEditClientSignature"
                                                ><span v-if="extinguisherReport.offline_client_signature_image != null || extinguisherReport.client_signature_image != null">Replace</span><span v-else>Add</span> signature</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('client_signed_by')]"
                                               for="client-name">Client Name</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="client_signed_by"
                                                    :class="['form-control', getFieldClasses('client_signed_by')]"
                                                    v-model="extinguisherReport.client_signed_by"
                                                    id="client-name"
                                                    @blur="onFieldBlur('client_signed_by')"
                                            /></div>
                                        <div v-if="isErrorField('client_signed_by')" class="invalid-feedback">This field is required</div>
                                    </div>
                                    
                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="client-sign-date">
                                            Client Sign Date
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="extinguisherReport.client_signed_date"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="client_signed_date"
                                                    id="client-sign-date"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
</template>

<style>
    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>

<script>
    import { required } from 'vuelidate/lib/validators'

    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';

    export default {
        data() {
            return {
                isEdit: false,
                addingEngineerSignature: false,
                addingClientSignature: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                extinguisherReport: {
                    site_extinguisher_report_id: Math.floor(new Date().getTime() / 1000),
                    extinguisher_report_id: null,
                    job_number: null,
                    prepared_by: null,
                    prepared_for: null,
                    tamper_tag_colour: null,
                    bs5306_3_compliant: null,
                    site_address: null,
                    date_of_inspection: new Date(),
                    overall_notes: null,
                    engineer_signature_image: null,
                    client_signature_image: null,
                    offline_engineer_signature_image: null,
                    offline_client_signature_image: null,
                    client_signed_by: null,
                    client_signed_date: null,
                    report_version: null
                }
            }
        },
        validations: {
            extinguisherReport: {
                job_number: { required },
                prepared_for: { required },
                site_address: { required },
            },
        },
        methods: {
            clearClientSignature() {
                this.$refs.clientSignaturePad.clearSignature();
            },
            saveClientSignature() {
                const { isEmpty, data } = this.$refs.clientSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.extinguisherReport.offline_client_signature_image = {
                        data: data
                    };
                }
                
                this.addingClientSignature = false;
                this.clearClientSignature();
            },
            addEditClientSignature() {
                this.addingClientSignature = true;
            },
            clearEngineerSignature() {
                this.$refs.engineerSignaturePad.clearSignature();
            },
            saveEngineerSignature() {
                const { isEmpty, data } = this.$refs.engineerSignaturePad.saveSignature();

                if(!isEmpty) {
                    this.extinguisherReport.offline_engineer_signature_image = {
                        data: data
                    };
                }
                
                this.addingEngineerSignature = false;
                this.clearEngineerSignature();
            },
            addEditEngineerSignature() {
                this.addingEngineerSignature = true;
            },
            getExtinguisherReport() {
                var vmt = this;
                this.getDb(function onConnectedGetDoorSets(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('extinguisher_reports').objectStore('extinguisher_reports');
                        var storeRequest = objectStore.get(reportId);

                        storeRequest.onsuccess = function(event) {
                            vm.extinguisherReport = storeRequest.result;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vm = this
                let request = new Promise((resolve, reject) => {
                    vm.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('extinguisher_reports', 'readwrite')
                            .objectStore('extinguisher_reports').put({
                                site_extinguisher_report_id: vm.extinguisherReport.site_extinguisher_report_id,
                                extinguisher_report_id: vm.extinguisherReport.extinguisher_report_id,
                                job_number: vm.extinguisherReport.job_number,
                                prepared_by: vm.extinguisherReport.prepared_by,
                                prepared_for: vm.extinguisherReport.prepared_for,
                                tamper_tag_colour: vm.extinguisherReport.tamper_tag_colour,
                                bs5306_3_compliant: vm.extinguisherReport.bs5306_3_compliant,
                                site_address: vm.extinguisherReport.site_address,
                                date_of_inspection: vm.extinguisherReport.date_of_inspection,
                                overall_notes: vm.extinguisherReport.overall_notes,
                                engineer_signature_image: vm.extinguisherReport.engineer_signature_image,
                                client_signature_image: vm.extinguisherReport.client_signature_image,
                                offline_engineer_signature_image: vm.extinguisherReport.offline_engineer_signature_image,
                                offline_client_signature_image: vm.extinguisherReport.offline_client_signature_image,
                                client_signed_by: vm.extinguisherReport.client_signed_by,
                                client_signed_date: vm.extinguisherReport.client_signed_date,
                                report_version: typeof vm.extinguisherReport.report_version == 'undefined' ? null : vm.extinguisherReport.report_version
                            });
                        putRequest.onsuccess = function(event) {
                            vm.submitSuccess({
                                success: true,
                                extinguisher_report_id: putRequest.result,
                            })
                        }
                        putRequest.onerror = function(event) {
                            alert("Unable to add data ");
                        }

                    })
                });
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'extinguisher-report-view', params: {action: 'view', id: response.extinguisher_report_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.extinguisherReport)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.extinguisherReport[field]) {
                    return this.$v.extinguisherReport[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        components: {
            Datepicker
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FER') === -1) {
                this.$router.push('/');
                return;
            }
            
            let reportId = this.$route.params.id;
            if (reportId) {
                this.isEdit = true;
                this.getExtinguisherReport();
            }
        },

    }
</script>